import React, { useState, useEffect, FC } from "react";
import { YhBox } from "@/components/YhBox";
import { Button, Checkbox, message, Table } from "antd";
import { ColumnsType, TablePaginationConfig } from "antd/lib/table";
import { DEFAULT_PAGE_SIZE, DEFAULT_FIRST_PAGE_NUM } from "@/utils/constants";
import { ISearchPage } from "@/types/FmsTypes";
import useGlobalModel from "@/model/globalModel";
import { ISCMPoHistoryDetails } from "./purchasePoTypes";
import { useRecordGoodsModel } from "./recordGoodsModel";
import { formatNum } from "@/utils/utils";
import { IDescription } from '@/components/YhBox/Types';
import { psiService } from './psiService';
import { convertRes2Blob } from '@/utils/exportFile';

const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }

export function PoTable() {
	const { user: { shopId }, setLoadingInfo, userBranch } = useGlobalModel();
	const {
		goodsRecordModal: { materialCode, code, orderType }
	} = useRecordGoodsModel();

	//列表数据源
	const [dataSource, setDataSource] = useState<ISCMPoHistoryDetails[]>([]);
	// 采购总数
	const [purchaseTotal, setPurchaseTotal] = useState<number>(0)
	const [loading, setLoading] = useState<boolean>(false);
	const [checked, setChecked] = useState(false)

	useEffect(() => {
		loadData();
	}, [])

	const loadData = async (page: ISearchPage = initPgCfg, allSupplierCode?: boolean) => {
		setLoading(true);
		try {
			const searchParams = {
				orgCode: allSupplierCode || orderType !== 'purchase' ? undefined : code,
				shopId,
				materialCode,
				types: ['io_spd', 'io_sprd'],
				pageNum: 1,
				pageSize: 1000
			}
			let total = 0
			let { retData } = await psiService.purchaseSaleHistoryDeatil(searchParams, userBranch);
			const newData = retData.map(item => {
				return {
					...item,
					orderType: item.type === 'io_sprd' ? '采退' : '采购',
					// num: item.type === 'io_sprd' ? -(item.num) : item.num,
					amount: item.num * item.price ?? 0,
					purchaseNum: item.type === 'io_sprd' ? -(item.num) : item.num
				}
			})
			newData.forEach(item => {
				total += item.purchaseNum
			})
			setPurchaseTotal(total)
			setDataSource(newData ?? []);
			setLoading(false)
		} catch (error) {
			setLoading(false);
			setDataSource([])
		}
	}

	const exportDetail = async () => {
		if (!dataSource.length) {
			message.warning("无数据");
			return;
		}
		setLoadingInfo({ loadingVisible: true, txt: "快速导出中" });
		try {
			const searchParams = {
				shopId,
				materialCode: materialCode,
				types: ['io_spd', 'io_sprd']
			}
			let result = await psiService.purchaseSaleStorageDeatilExport(searchParams);
			result && setLoadingInfo({ loadingVisible: false, txt: "" });
			convertRes2Blob(result);
		}
		catch { setLoadingInfo({ loadingVisible: false, txt: "" }) }
	}

	const action = <>
		{/* <YhAuth resCode={ResourceAuthEnum.ST_DB_EX}> */}
		<Button
			className="mr-5"
			type="link"
			shape="round"
			onClick={() => exportDetail()}
		>导出</Button>
		{/* </YhAuth> */}
	</>;

	const desc: IDescription[] = [
		// {
		// 	label: "采购数量",
		// 	value: purchaseTotal,
		// 	color: DescriptionColorEnum.red

		// }
	]


	const columns: ColumnsType<ISCMPoHistoryDetails> = [
		{
			title: '序号',
			width: 66,
			align: "center",
			render: (t: any, r: any, i: number) => i + 1
		}, {
			title: '单位名称',
			width: 160,
			align: "center",
			dataIndex: 'orgName',
			render: text => <p className="ellipsis" title={text}>{text}</p>
		}, {
			title: '单据编号',
			width: 186,
			align: "center",
			dataIndex: 'code',
		}, {
			title: '单价',
			width: 136,
			align: "center",
			dataIndex: 'price',
			render: text => `￥${formatNum(text)}`
		}, {
			title: '数量',
			width: 100,
			align: "center",
			dataIndex: 'num',
			render: (text, record) => record.orderType === 'io_sprd' ? -(text) : text
		}, {
			title: '业务日期',
			width: 180,
			align: "center",
			dataIndex: 'createTime',
		}, {
			title: '出入库日期',
			width: 180,
			align: "center",
			dataIndex: 'stockIoTime',
		}, {
			title: '金额',
			width: 136,
			align: "center",
			dataIndex: 'amount',
			render: text => `￥${formatNum(text)}`
		}, {
			title: '业务员',
			width: 100,
			align: "center",
			dataIndex: 'createUser',
		}, {
			title: '备注',
			width: 100,
			align: "center",
			dataIndex: 'note',
		}, {
			title: '采购类型',
			width: 80,
			align: "center",
			dataIndex: 'typeName',
		}, {
			title: '优惠类型',
			width: 120,
			align: "center",
			dataIndex: 'preferentialTypeName',
		}, {
			title: '单据类型',
			width: 140,
			align: "center",
			dataIndex: 'orderType',
		},
		{
			title: '调拨单号',
			width: 200,
			align: "center",
			dataIndex: 'transferCode',
		},
	];

	const rightChildren = <Checkbox checked={checked} onChange={(e) => { setChecked(e.target.checked); loadData(initPgCfg, e.target.checked) }}>
		所有单位
	</Checkbox>

	return <YhBox title={action} rightChildren={orderType === 'purchase' ? rightChildren : <></>} style={{ marginBottom: "15px" }}>
		<Table
			rowKey={record => record.id}
			loading={loading}
			columns={columns}
			dataSource={dataSource}
			pagination={false}
			scroll={{ x: 'max-content', y: 340 }}
		/>
	</YhBox>
}